import "./productItem.css";

const ProductItem = ({
  product,
  language,
  getProductName,
  addToCart,
  actionText = "Add to Cart"
}) => {
  return (
    <div
      key={product.id}
      style={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "15px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div>
        <h3 style={{ margin: "0 0 10px 0" }}>
          {getProductName(product, language)}
        </h3>
        <p style={{ margin: '0 0 10px 0' }}>Provider: {product.provider}</p>
      </div>
      {
        <button onClick={() => addToCart(product)} className="button">
          {actionText}
        </button>
      }
    </div>
  );
};

export default ProductItem;
